export interface Article {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  updateDate: string;
  tags: string[];
  featured: boolean;
  views: number;
}

export const articles: Article[] = [
  {
    slug: 'jinquan-yisheng-zhongwen-zimu',
    title: '《金权医生》最新中文字幕资源推荐 — 第8集字幕已更新',
    category: 'riju',
    categoryName: '日韩剧集',
    excerpt: '热门日剧《金权医生》第8集中文字幕已由字幕组完成制作，翻译质量优秀，时间轴精准。本文提供详细的字幕获取方式和使用教程。',
    content: `<h2>《金权医生》简介</h2>
<p>《金权医生》是2026年夏季档最受关注的日剧之一，讲述了一位天才外科医生在金钱与权力的漩涡中坚守医者仁心的故事。由当红演员主演，剧情紧凑，每集都有令人意想不到的转折。</p>

<h2>第8集中文字幕详情</h2>
<p>第8集的字幕由"日剧字幕组"精心制作，翻译团队包括资深日语翻译和医学专业顾问，确保了医学术语的准确性。时间轴经过多次校对，与画面完美同步。</p>

<h3>字幕特点</h3>
<ul>
<li>✅ 中日双语对照显示</li>
<li>✅ 医学术语专业翻译</li>
<li>✅ 时间轴精准到毫秒</li>
<li>✅ 支持多种播放器加载</li>
<li>✅ 字体大小可调节</li>
</ul>

<h2>如何使用字幕</h2>
<p>下载的字幕文件为标准的SRT格式，兼容市面上几乎所有主流播放器。推荐使用PotPlayer或VLC播放器，将字幕文件与视频文件放在同一文件夹中，保持文件名一致即可自动加载。</p>

<h3>常见播放器设置方法</h3>
<p><strong>PotPlayer：</strong>右键 → 字幕 → 加载字幕 → 选择SRT文件</p>
<p><strong>VLC：</strong>字幕 → 添加字幕文件 → 选择SRT文件</p>
<p><strong>MPC-HC：</strong>文件 → 加载字幕 → 选择SRT文件</p>

<h2>字幕组推荐语</h2>
<blockquote>这一集的台词量非常大，尤其是手术场景的医学术语翻译，我们请教了多位医学专业人士，力求每一个术语都准确无误。希望这份字幕能帮助大家更好地理解剧情。</blockquote>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20drama%20scene%20with%20surgeon%20in%20operating%20room%2C%20dramatic%20lighting%2C%20warm%20tones%2C%20professional%20atmosphere%2C%20Japanese%20TV%20drama%20style%2C%20clean%20cinematic%20look%2C%20soft%20depth%20of%20field&width=800&height=450&seq=article-1-cover&orientation=landscape',
    author: '字幕君',
    publishDate: '2026-08-12',
    updateDate: '2026-08-12',
    tags: ['日剧', '金权医生', '医疗剧', '中文字幕', '2026夏季档'],
    featured: true,
    views: 12856,
  },
  {
    slug: 'handiguo-wangfei-zhongwen-zimu',
    title: '《韩帝国王妃》中文字幕全16集整理 — 宫廷爱情巨制',
    category: 'riju',
    categoryName: '日韩剧集',
    excerpt: '《韩帝国王妃》全16集中文字幕已整理完毕，这部韩国宫廷爱情巨制讲述了一段跨越阶级的动人爱情故事，字幕翻译精良。',
    content: `<h2>《韩帝国王妃》剧情概述</h2>
<p>《韩帝国王妃》是2026年最受瞩目的韩国古装剧，以架空的历史背景讲述了平民女子意外成为王妃后，在宫廷斗争中坚守爱情与正义的故事。全剧16集，每集约70分钟。</p>

<h2>中文字幕资源说明</h2>
<p>本次整理的字幕资源由"韩剧字幕联盟"提供，全16集的字幕均已完成翻译和校对。翻译风格流畅自然，古语部分做了详细注释，方便观众理解韩国古代宫廷文化。</p>

<h3>字幕亮点</h3>
<ul>
<li>📜 古语术语均有注释说明</li>
<li>🎵 插曲歌词同步翻译</li>
<li>📝 历史背景知识补充</li>
<li>🔤 人名地名统一翻译标准</li>
</ul>

<h2>剧集看点</h2>
<p>本剧最大的亮点在于精良的服化道和演员的精湛演技。女主角从天真烂漫的少女成长为沉稳果敢的王妃，角色弧光完整而动人。剧中的宫廷礼仪和传统服饰也经过了历史考据，还原度极高。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20palace%20drama%20scene%20with%20elegant%20hanbok%20costumes%2C%20warm%20golden%20lighting%2C%20traditional%20Korean%20architecture%2C%20romantic%20atmosphere%2C%20cinematic%20quality%2C%20soft%20natural%20colors&width=800&height=450&seq=article-2-cover&orientation=landscape',
    author: '韩剧迷',
    publishDate: '2026-08-10',
    updateDate: '2026-08-11',
    tags: ['韩剧', '韩帝国王妃', '古装剧', '中文字幕', '宫廷爱情'],
    featured: true,
    views: 9567,
  },
  {
    slug: 'dongjing-guaitan-dianying-zimu',
    title: '《东京怪谈》电影中文字幕 — 日本恐怖片年度佳作',
    category: 'dianying',
    categoryName: '日韩电影',
    excerpt: '日本恐怖电影《东京怪谈》中文字幕已发布，这部由知名恐怖片导演执导的作品延续了日式恐怖的精髓，字幕翻译精准捕捉了日式恐怖的氛围感。',
    content: `<h2>《东京怪谈》电影介绍</h2>
<p>《东京怪谈》是2026年日本恐怖电影的代表作，由著名恐怖片导演执导，以东京都市传说为背景，通过三个相互关联的恐怖故事，展现了现代都市中的诡异与恐惧。影片在日本上映后获得了极高的评价。</p>

<h2>字幕翻译特色</h2>
<p>恐怖片的字幕翻译难度较大，需要在保留原意的同时传达出恐怖氛围。本次字幕由"恐影字幕组"制作，翻译团队在恐怖片字幕领域有丰富经验。</p>

<h3>翻译亮点</h3>
<ul>
<li>👻 恐怖氛围用语精准传达</li>
<li>🎬 片中日语方言特殊标注</li>
<li>📖 都市传说背景补充说明</li>
<li>🔊 环境音效文字提示</li>
</ul>

<h2>观影建议</h2>
<p>建议在夜间关灯观看以获得最佳恐怖体验。片中有几处高能惊吓场景，胆小的观众请做好心理准备。字幕中的环境音效提示能帮助你更好地感受日式恐怖的细腻之处。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20horror%20film%20atmospheric%20scene%20with%20dim%20lighting%2C%20Tokyo%20urban%20setting%2C%20eerie%20mood%2C%20cinematic%20quality%2C%20dark%20tones%2C%20mysterious%20shadow%2C%20subtle%20warm%20accents&width=800&height=450&seq=article-3-cover&orientation=landscape',
    author: '恐影达人',
    publishDate: '2026-08-08',
    updateDate: '2026-08-09',
    tags: ['日本电影', '恐怖片', '东京怪谈', '中文字幕', '日式恐怖'],
    featured: true,
    views: 7234,
  },
  {
    slug: 'runningman-2026-8yue-zimu',
    title: '《Running Man》2026年8月最新中文字幕合集',
    category: 'zongyi',
    categoryName: '日韩综艺',
    excerpt: '韩国超人气综艺《Running Man》2026年8月最新几集的中文字幕已整理发布，搞笑名场面不断，字幕翻译保留了原汁原味的韩式综艺趣味。',
    content: `<h2>《Running Man》8月精彩看点</h2>
<p>《Running Man》作为韩国最长寿的综艺节目之一，8月份迎来了多位重量级嘉宾，游戏环节也进行了全新升级。本月中文字幕由"RM字幕组"提供，翻译风格轻松活泼，完美还原了节目中的笑点和梗。</p>

<h2>字幕质量说明</h2>
<p>综艺字幕的翻译难点在于文化梗和即兴发挥的部分。RM字幕组的翻译团队均为资深Running Man粉丝，对节目中的各种内部梗了如指掌。</p>

<h3>本月精彩集数</h3>
<ul>
<li>🎯 EP678：偶像运动会特辑（上）— 爱豆们大展身手</li>
<li>🏃 EP679：偶像运动会特辑（下）— 爆笑接力赛</li>
<li>🍜 EP680：美食追击战 — 首尔隐藏美食大作战</li>
<li>👻 EP681：夏日纳凉特辑 — 鬼屋逃脱大挑战</li>
</ul>

<h2>字幕使用小贴士</h2>
<p>综艺节目中常有多人同时说话的情况，字幕采用了不同颜色区分不同成员的发言，让你不会错过任何一句精彩的吐槽和互动。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20Running%20Man%20style%20scene%20with%20bright%20colorful%20studio%20lighting%2C%20energetic%20atmosphere%2C%20game%20show%20setting%2C%20cheerful%20vibrant%20mood%2C%20clean%20modern%20broadcast%20style&width=800&height=450&seq=article-4-cover&orientation=landscape',
    author: 'RM铁粉',
    publishDate: '2026-08-07',
    updateDate: '2026-08-11',
    tags: ['韩国综艺', 'Running Man', '刘在石', '中文字幕', '综艺'],
    featured: false,
    views: 15230,
  },
  {
    slug: 'jujiang-kaidong-zuizhongji-zimu',
    title: '《巨匠开动！最终季》日漫中文字幕全季资源整理',
    category: 'fanju',
    categoryName: '日韩番剧',
    excerpt: '超人气美食番《巨匠开动！最终季》全12集中文字幕已全部更新完毕，这部陪伴了观众五年的美食动画迎来了感人至深的结局。',
    content: `<h2>《巨匠开动！最终季》完结感言</h2>
<p>五年的陪伴，终于迎来了终章。《巨匠开动！》作为近年来最出色的美食题材动画，不仅展现了令人垂涎欲滴的美食画面，更通过料理讲述了人与人之间的温情故事。最终季12集，每一集都是一场视觉与情感的盛宴。</p>

<h2>字幕制作团队</h2>
<p>本季字幕由"美食番字幕组"倾情制作，翻译团队对料理术语进行了细致的考据。从法式料理到日式传统和食，每一道菜品的名称和做法描述都经过了反复核对。</p>

<h2>最终季高光时刻</h2>
<p>建议准备好纸巾，最终季的催泪程度远超前面几季。尤其是第11集和第12集，几乎每一幕都能让人感动落泪。字幕中的料理术语注解会让你对每一道菜品有更深入的理解。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20food%20scene%20with%20beautiful%20cuisine%20presentation%2C%20warm%20cozy%20kitchen%20atmosphere%2C%20hand-drawn%20anime%20style%2C%20golden%20evening%20light%2C%20soft%20colors%2C%20appetizing%20dish%20closeup&width=800&height=450&seq=article-5-cover&orientation=landscape',
    author: '动漫宅',
    publishDate: '2026-08-05',
    updateDate: '2026-08-10',
    tags: ['日本动漫', '美食番', '巨匠开动', '最终季', '中文字幕'],
    featured: true,
    views: 11234,
  },
  {
    slug: 'zuixin-riben-dianshiju-8yue-zimu',
    title: '2026年8月最新日本电视剧中文字幕更新汇总',
    category: 'zuixin',
    categoryName: '最新更新',
    excerpt: '8月最新更新的日剧中文字幕资源汇总，涵盖《金权医生》《东京爱情故事2026》《深夜食堂：新篇》等多部热门日剧的最新集数字幕。',
    content: `<h2>8月日剧中文字幕更新一览</h2>
<p>本月日剧字幕更新频率稳定，多部热门剧集保持与日本播出同步的字幕更新速度。以下是本月已更新的主要剧集字幕资源汇总。</p>

<h2>本周热门更新</h2>
<h3>《金权医生》第8集</h3>
<p>字幕已更新，翻译质量优秀，医学术语准确。</p>

<h3>《东京爱情故事2026》第6集</h3>
<p>经典翻拍的全新演绎，字幕翻译保留原版韵味。</p>

<h3>《深夜食堂：新篇》第3集</h3>
<p>温暖人心的美食故事，字幕精准传达了台词的温情。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20TV%20drama%20collage%20with%20multiple%20scenes%2C%20modern%20Tokyo%20cityscape%2C%20warm%20evening%20lighting%2C%20cozy%20indoor%20settings%2C%20clean%20cinematic%20style%2C%20soft%20color%20palette&width=800&height=450&seq=article-6-cover&orientation=landscape',
    author: '日剧速递',
    publishDate: '2026-08-12',
    updateDate: '2026-08-12',
    tags: ['日剧', '最新更新', '中文字幕', '2026夏季档', '汇总'],
    featured: false,
    views: 18650,
  },
  {
    slug: 'potplayer-jiazai-zimu-jiaocheng',
    title: 'PotPlayer加载中文字幕完整教程 — 新手必看',
    category: 'jiaocheng',
    categoryName: '使用教程',
    excerpt: '详细图解PotPlayer播放器加载中文字幕的完整步骤，包括字幕格式转换、字体设置、时间轴微调等实用技巧，零基础也能轻松学会。',
    content: `<h2>PotPlayer字幕加载完整指南</h2>
<p>PotPlayer是Windows平台上最受欢迎的免费播放器之一，对字幕的支持非常完善。本教程将从零开始，教你如何使用PotPlayer加载和管理中文字幕。</p>

<h2>第一步：下载并安装PotPlayer</h2>
<p>访问PotPlayer官方网站下载最新版本。安装过程非常简单，一路"下一步"即可完成。建议安装64位版本以获得最佳性能。</p>

<h2>第二步：准备字幕文件</h2>
<p>字幕文件通常为SRT、ASS或SSA格式。将下载的字幕文件与视频文件放在同一文件夹中，并确保字幕文件名与视频文件名相同（后缀名不同）。</p>

<h2>第三步：自动加载字幕</h2>
<p>当字幕文件与视频文件同名且在同一文件夹时，PotPlayer会自动加载字幕。打开视频即可在画面底部看到字幕显示。</p>

<h2>第四步：手动加载字幕</h2>
<p>如果字幕没有自动加载，可以右键点击播放画面 → 字幕 → 加载字幕 → 选择你的SRT文件。</p>

<h2>第五步：字幕样式调整</h2>
<p>右键 → 字幕 → 字幕样式，可以调整字体、大小、颜色、位置、透明度等参数。建议将字体设置为"微软雅黑"或"Noto Sans SC"，字号根据屏幕大小调整。</p>

<h2>常见问题解决</h2>
<h3>字幕乱码怎么办？</h3>
<p>右键 → 字幕 → 字幕编码 → 选择"UTF-8"即可解决大部分乱码问题。</p>

<h3>字幕与画面不同步？</h3>
<p>使用快捷键调整：按"["键使字幕提前0.5秒，按"]"键使字幕延后0.5秒。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20computer%20desktop%20with%20video%20player%20interface%20showing%20subtitles%2C%20clean%20workspace%2C%20warm%20ambient%20lighting%2C%20minimalist%20setup%2C%20professional%20screenshot%20style&width=800&height=450&seq=article-7-cover&orientation=landscape',
    author: '技术小编',
    publishDate: '2026-07-20',
    updateDate: '2026-08-10',
    tags: ['教程', 'PotPlayer', '字幕加载', '播放器', '新手'],
    featured: false,
    views: 25678,
  },
  {
    slug: 'hdl-jiejue-zimu-butongbu',
    title: '如何解决中文字幕与视频不同步的问题 — 实用方法汇总',
    category: 'jiaocheng',
    categoryName: '使用教程',
    excerpt: '中文字幕与视频不同步是字幕爱好者常遇到的问题。本文总结了5种实用的解决方法，从播放器内置功能到专业字幕编辑工具，总有一种适合你。',
    content: `<h2>字幕不同步？别担心，这里有解决方案</h2>
<p>字幕与视频不同步是最常见的问题之一，通常表现为字幕提前或延后显示。以下是几种有效的解决方法，从简单到复杂排列。</p>

<h2>方法一：播放器快捷键实时调整</h2>
<p>最简单的方法，在观看时实时调整。PotPlayer按"["和"]"，VLC按"G"和"H"，MPC-HC按"F1"和"F2"。</p>

<h2>方法二：使用字幕编辑工具</h2>
<p>推荐使用Subtitle Edit（免费开源），可以批量调整时间轴。导入SRT文件后，选择"同步 → 调整所有时间"，输入偏移量即可。</p>

<h2>方法三：在线字幕同步工具</h2>
<p>如果不想安装软件，可以使用在线字幕同步工具，上传SRT文件后在浏览器中调整。</p>

<h2>方法四：检查视频帧率</h2>
<p>有时字幕是为不同帧率的视频制作的（如23.976fps vs 25fps），这时需要用Subtitle Edit进行帧率转换。</p>

<h2>方法五：重新下载匹配版本</h2>
<p>如果以上方法都无效，建议在本站搜索对应视频版本的专属字幕资源。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Subtitle%20editing%20software%20interface%20on%20computer%20screen%2C%20timeline%20editor%20with%20text%20tracks%2C%20clean%20UI%20design%2C%20warm%20desk%20setup%2C%20professional%20work%20environment&width=800&height=450&seq=article-8-cover&orientation=landscape',
    author: '技术小编',
    publishDate: '2026-07-15',
    updateDate: '2026-08-08',
    tags: ['教程', '字幕同步', '字幕编辑', '问题解决', '实用技巧'],
    featured: false,
    views: 18923,
  },
  {
    slug: 'hanguo-dianying-tuijian-2026',
    title: '2026年必看韩国电影推荐 — 附中文字幕资源指南',
    category: 'dianying',
    categoryName: '日韩电影',
    excerpt: '盘点2026年最值得观看的韩国电影，从商业大片到独立佳作，每部都附有中文字幕资源获取方式，影迷不容错过。',
    content: `<h2>2026韩国电影年度推荐</h2>
<p>2026年韩国电影市场精彩纷呈，从悬疑惊悚到温情喜剧，各种类型都有出彩之作。我们精选了以下几部必看佳作，并整理了对应的中文字幕资源。</p>

<h2>TOP 5 推荐影片</h2>

<h3>1.《汉江之夜》— 悬疑惊悚</h3>
<p>讲述汉江边发生的一系列离奇失踪事件，节奏紧凑，反转连连。</p>

<h3>2.《母亲的选择》— 家庭剧情</h3>
<p>一位单身母亲在困境中为孩子的未来做出艰难抉择，催泪指数满星。</p>

<h3>3.《地下拳场》— 动作犯罪</h3>
<p>地下格斗场的热血故事，动作场面精彩绝伦。</p>

<h3>4.《济州岛的夏天》— 浪漫爱情</h3>
<p>在济州岛美景中展开的治愈系爱情故事，画面美到窒息。</p>

<h3>5.《最后的检察官》— 法庭剧情</h3>
<p>关于正义与权力博弈的法庭剧，演技派阵容强大。</p>

<h2>字幕资源获取方式</h2>
<p>以上所有电影的韩语中文字幕均可通过本站的资源导航页面找到对应的字幕下载链接。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20movie%20theater%20scene%20with%20film%20posters%2C%20warm%20cinematic%20lighting%2C%20modern%20theater%20interior%2C%20elegant%20atmosphere%2C%20clean%20composition%2C%20professional%20movie%20photography&width=800&height=450&seq=article-9-cover&orientation=landscape',
    author: '影评人小王',
    publishDate: '2026-08-01',
    updateDate: '2026-08-10',
    tags: ['韩国电影', '电影推荐', '中文字幕', '2026', '影评'],
    featured: false,
    views: 8765,
  },
  {
    slug: 'riben-donghua-xinfan-8yue',
    title: '2026年8月日本新番动漫中文字幕更新一览',
    category: 'fanju',
    categoryName: '日韩番剧',
    excerpt: '8月日本新番动漫中文字幕实时更新追踪，包含热门续作和新番首播的字幕资源导航，追番党必备。',
    content: `<h2>8月新番中文字幕更新清单</h2>
<p>2026年夏季番正在热播中，本月有多部重磅新番开播，也有多部人气续作回归。我们整理了最新的中文字幕更新情况。</p>

<h2>热门新番字幕状态</h2>

<h3>《剑与魔法与异世界》第二季</h3>
<p>字幕更新至第5集，翻译质量稳定，魔法术语翻译精准。</p>

<h3>《夏日物语2026》</h3>
<p>原创动画新番，首集字幕已发布，清新治愈风格。</p>

<h3>《机甲战队：新生》</h3>
<p>机甲战斗番，字幕更新至第6集，战斗场景术语翻译到位。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20summer%20scene%20with%20vibrant%20colors%2C%20anime%20style%20illustration%2C%20blue%20sky%20and%20cityscape%2C%20youthful%20energy%2C%20clean%20art%20style%2C%20warm%20sunlight&width=800&height=450&seq=article-10-cover&orientation=landscape',
    author: '动漫宅',
    publishDate: '2026-08-03',
    updateDate: '2026-08-11',
    tags: ['日本动漫', '新番', '夏季番', '中文字幕', '追番'],
    featured: false,
    views: 14320,
  },
];